/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    assetCompanyId: {},
    assetCompanyIdArr: {},
    assetAnlkl: {},
    assetAnlklArr: {},
    // 设备参数管理页面的左侧树至表格传参使用
    typeCode: {}
  },
  getters: {
    assetCompanyId: state => state.assetCompanyId,
    // 用于图表弹窗
    assetCompanyIdArr: state => state.assetCompanyIdArr,
    assetAnlkl: state => state.assetAnlkl,
    // 用于图表弹窗
    assetAnlklArr: state => state.assetAnlklArr,
    typeCode: state => state.typeCode
  },
  mutations: {
    assetCompanyId: (state, data) => {
      state.assetCompanyId = data
    },
    assetCompanyIdArr: (state, data) => {
      state.assetCompanyIdArr = data
    },
    assetAnlkl: (state, data) => {
      state.assetAnlkl = data
    },
    assetAnlklArr: (state, data) => {
      state.assetAnlklArr = data
    },
    typeCode: (state, data) => {
      state.typeCode = data
    }
  },
  actions: {
    handleAssetCompanyId (assetCompanyId, data) {
      assetCompanyId.commit('assetCompanyId', data)
    },
    handleAssetCompanyIdArr (assetCompanyIdArr, data) {
      assetCompanyIdArr.commit('assetCompanyIdArr', data)
    },
    handleAssetAnlkl (assetAnlkl, data) {
      assetAnlkl.commit('assetAnlkl', data)
    },
    handleAssetAnlklArr (assetAnlklArr, data) {
      assetAnlklArr.commit('assetAnlklArr', data)
    },
    handleTypeCode (typeCode, data) {
      typeCode.commit('typeCode', data)
    }
  }
}
